module.exports = __webpack_public_path__ + "img/example_annotated_generated.10863f9b.png";